export default __webpack_public_path__ + "static/media/visual_04.08838f88.png";